module.exports = __webpack_public_path__ + "static/media/eduImgBlack.4bc4ab19.svg";